export class User {
  constructor() {
    this.created_at = null;
    this.updated_at = null;
    this.email = null;
    this.first_name = null;
    this.last_name = null;
    this.phone = null;
    this.superuser = null;
    this.id = null;
    this.password = null;
    this.role = null;

    this.hospital = null;
    this.city = null;
    this.country = null;

    this.gender = 0;
  }
}
